// utils/storage.ts
interface Stored<T> {
  value: T;
  expires: number; // timestamp em ms (Date.now())
}

/**
 * Salva algo no localStorage com prazo de validade (TTL em milissegundos)
 */
export const setWithTTL = <T>(key: string, value: T, ttl: number) => {
  const record: Stored<T> = { value, expires: Date.now() + ttl };
  localStorage.setItem(key, JSON.stringify(record));
};

/**
 * Lê um item; se estiver expirado, remove e devolve null
 */
export const getWithTTL = <T>(key: string): T | null => {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const record = JSON.parse(raw) as Stored<T>;
    if (Date.now() > record.expires) {
      localStorage.removeItem(key);
      return null;
    }
    return record.value;
  } catch {
    // JSON quebrado? remove por segurança
    localStorage.removeItem(key);
    return null;
  }
};
